import React from 'react';
import { useEffect, useRef, useState } from 'react'
import {
  SDrawerOrModal,
  SLowcodeList,
} from 'shj-components';
import {
  getAuthorizeEmployee,
  assignRelatives,
  queryEmployeeForReassign,
  getEmployee
} from "@/services/customerServices.ts";
import { message } from 'antd';
import { config } from './config/index.tsx'
import styles from './index.module.less'
import {assignEmployee, queryClueEmployeeForReassign, queryEmployeePage} from "@/services/callCenter";
import {clueBatchAssign} from "@/services/saleOpServices.ts";
import {getRoleListFn} from "@/services/member.ts";

const typeMap = {
  ['ASSIGN_SALES']: '分配营销员',
  ['REASSIGN_SALES']: '改派营销员',
  ['APPOINT_DISPATCH']: '分配营销员',
  ['DISPATCH']: '分配营销员',
  ['ASSIGN_DESIGNER_MNR']: '分配设计部经理',
  ['ASSIGN_DESIGNER']: '分配设计师',
  ['ASSIGN_SEAT_MAN']: '分配云客服',
  ['ASSIGN_CALL_MNR']: '分配呼叫经理',
  ['ASSIGN_SALES_MNR']: '分配营销部经理',
  ['ASSIGN_ELECTRIC']: '分配电商专员',
  ['ASSIGN_ELECTRIC_MNR']: '分配电商经理',
  ['ASSIGN_ASSIST']: '分配分公司总助',
  ['ASSIGN_DELIVERY_ASSISTANT']: '分配分公司交付助理',
  ['ASSIGN_DEEPENING_DESIGNER']: '分配深化设计师',
  ['ASSIGN_SOFT_DESIGN_MNR']: '分配软装设计部经理',
  ['ASSIGN_SOFT_DESIGN']: '分配软装设计师',
  ['ASSIGN_TAILOR_MADE_DESIGN_MNR']: '分配定制设计部经理',
  ['ASSIGN_TAILOR_MADE_DESIGN']: '分配定制设计师',
  ['ASSIGN_ACHIEVEMENT_DESIGN']: '关联业绩设计师',
  ['ASSIGN_CHU_GUI_WARDROBE_DESIGN']: '分配橱柜设计师',
  ['ASSIGN_DELIVERY_ACHIEVEMENT']: '关联交付业绩人员',
  ['ASSIGN_DELIVERY_ACHIEVEMENT_MNR']: '关联交付业绩部门经理',
  ['ASSIGN_MEMBER_CALL_CENTER']: '关联会员客服',
}

export default function AllowcateWorkerModal (props)  {
  const {
    editId = '',
    isEditTitle = '',
    title = '',
    open = false,
    isListOperation = false,
    isBatch = false,
    changeFlag = false,
    tab = '',
    trackPlanNodeId = '',
    trackPlanId = undefined,
    buttonKey = '',
    orgId = undefined,
    requestApi = undefined,
    assignApi = undefined,
    onClose = () => {},
    reload = () => {},
    submitQuery = {},
      searchQuery = {}
  } = props

  const listRef = useRef()
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    console.log(buttonKey)
  }, []);

  const fetchList = async values => {
    //  queryClueEmployeeForReassign({trackPlanNodeId: id, clueId: editId})
    const query = {
      queryEmployee: true,
      queryOrg: true,
      button: buttonKey,
      ...values.query,
      ...searchQuery
    }
    try {
      let res: any = {};
      if(isEditTitle === '改派'){// 改派s
        if (isListOperation){
          res = await getEmployee({pageId: values.current, pageSize: values.pageSize, employeeFilter: {userNameKeyword: values?.query?.userName}, orgId, trackPlanId, ...query})
        } else {
          res = await queryEmployeePage({data: {clueId: editId, userNameKeyword: values?.query?.userName, trackPlanNodeId, trackPlanId, ...query}, params: {pageId: values.current, pageSize: values.pageSize}})
        }

      }else{ // 分配
        if (requestApi) {
          res = await requestApi({data: {...query, employeeFilter: {userNameKeyword: values?.query?.userName}, companyId: orgId, trackPlanId}, params: {pageId: values.current, pageSize: values.pageSize}})
        } else {
         res = await queryEmployeePage({params: {pageId: values?.current, pageSize: values.pageSize}, data:{...values,clueId: editId, userNameKeyword: values?.query?.userName, trackPlanNodeId, trackPlanId, ...query}});
        }
      }
      // if (tab === '5') {
      //   { ...values, pageId: values?.current, employeeFilter: { userNameKeyword: values?.query?.userName }, queryEmployee: true, queryOrg: true,  companyId: orgId }
      // } else {
      //   if (!changeFlag) {
      //     res = await getAuthorizeEmployee({ ...values, pageId: values?.current, userNameKeyword: values?.query?.userName, trackPlanId: editId });
      //   } else {
      //     res = await queryClueEmployeeForReassign({ ...values, pageId: values?.current, userNameKeyword: values?.query?.userName, trackPlanNodeId });
      //   }
      // }
      if (!res?.list) {
        message.error('查询列表失败');
        return;
      }
      return {
        records: res?.list,
        total: res?.count,
      };
    } catch (err) {
      console.log(err)
    }
  }

  const onSubmit = async () => {
    if(!selectedRowKeys[0]){
      message.error('请选择数据')
      return;
    }
    try {
      let res: any = {};
      const apiFn = assignApi ? assignApi : (isListOperation ? clueBatchAssign : assignEmployee)
      setLoading(true)
      res = await apiFn({
        ...submitQuery,
        [isBatch ? 'clueIds' : 'clueId']: editId || undefined,
        buttonKey,
        [isBatch ? 'trackPlanIds' : 'trackPlanId']: trackPlanId || undefined,
        relatives: {
            ucenterUserId: (selectedRowKeys?.[0] as any).ucenterUserId,
            name: (selectedRowKeys?.[0] as any).userName,
            deptId: (selectedRowKeys?.[0] as any)?.orgId,
            companyId: (selectedRowKeys?.[0] as any)?.companyId,
            roleCode: (selectedRowKeys?.[0] as any)?.roleCode,
          }
      });
      if (res.errorCode === 0 && res.status) {
        message.success(`${title || typeMap[buttonKey]}成功`);
        onClose();
        reload();
      } else {
        message.error(`${title || typeMap[buttonKey]}失败`);
      }
      setLoading(false)
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const fetchPropApi = async(values) => {
    try {
      const res = await requestApi({data: {pageId: values.current, pageSize: values.pageSize, employeeFilter: {userNameKeyword: values?.query?.userName}, orgId}})
      return {
        records: res?.list,
        total: res?.count,
      };
    } catch (e) {

    }

  }

  const getStatusOptions = async () => {
    const roleList = await getRoleListFn({ data: {  } })
    return Promise.resolve({roleList})
  }

  // 表格配置
  const extensions = {
    request: { fetchList, getStatusOptions },
    onSelectedRowChange: (keys, rows) => {
      setSelectedRowKeys(rows)
    },
  }

  return (
    <div>
      <SDrawerOrModal
        mode="drawer"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        width={900}
        loading={loading}
        title={title ? title : isEditTitle ? typeMap[buttonKey]?.replace(/分配|关联/, isEditTitle) : typeMap[buttonKey]}
      >
        <div className={styles.drawerTableBox}>
        <SLowcodeList ref={listRef} searchMode="group" config={{...config}} {...extensions} />
        </div>
      </SDrawerOrModal>
    </div>
  )
}